function init() {
  const $BookEdition = jQuery('.BookEdition');
  if (!$BookEdition.length) return;

  initBookEdition($BookEdition);
  checkUrlHash();
}

function initBookEdition($BookEdition) {
  $BookEdition.on('click', function () {
    $BookEdition.removeClass('active');
    jQuery(this).addClass('active');

    var paragraphId = jQuery(this).data('paragraph');
    var nodeId = jQuery(this).data('node');

    loadParagraph(nodeId, paragraphId);
  });
}

function loadParagraph(nodeId, paragraphId) {
  jQuery.ajax({
    url: '/paragraph-api/' + nodeId + '/' + paragraphId,
    method: 'GET',
    dataType: 'json',
    success: function (data) {
      if (data.titre) {
        jQuery('.BookHeader-infos--title').html(data.titre);
      }
      if (data.couv_uri) {
        jQuery('.BookHeader-cover img').attr('src', data.couv_uri);
      }
      if (data.date_publication) {
        jQuery('.BookMetas-intro strong').html(data.date_publication);
      }
      if (data.description.ean) {
        jQuery('.BookEditions-ean').html('EAN : ' + data.description.ean);
      }
      if (data.description.edition_width) {
        jQuery('.BookEditions-width').html(data.description.edition_width + ' mm x');
      } else {
        jQuery('.BookEditions-width').html('');
      }
      if (data.description.edition_length) {
        jQuery('.BookEditions-length').html(data.description.edition_length + ' mm - ');
      } else {
        jQuery('.BookEditions-length').html('');
      }
      if (data.description.pages && data.description.pages > 0) {
        jQuery('.BookEditions-pages').html(data.description.pages + ' pages');
      } else {
        jQuery('.BookEditions-pages').html('');
      }
      if (data.description.price && parseFloat(data.description.price) > 0) {
        jQuery('.BookEditions-price').html(data.description.price + ' €');
      } else {
        jQuery('.BookEditions-price').html('');
      }
    },
    error: function (error) {
      console.error('Erreur lors de la récupération du paragraphe :', error);
    }
  });
}

function checkUrlHash() {
  const hash = window.location.hash.substring(1);
  if (hash) {
    const $targetEdition = jQuery(`.BookEdition[data-paragraph="${hash}"]`);
    if ($targetEdition.length) {
      $targetEdition.trigger('click');
    }
  }
}

export default { init };
